import * as Yup from 'yup';
import { AnyObject, TestContext, ValidationError } from 'yup';
import { validateSn } from './snValidationScheme';

export const originalValidationSchemeCustomer = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>,
  computerRequired: boolean
) =>
  Yup.object({
    sn: validateSn(checkSn),
    imo_nr: Yup.number().required('This field is required'),
    schiffsname: Yup.string().required('This field is required'),
    email: Yup.string().required('This field is required'),
    produktionsdatum: Yup.string().required('This field is required'),
    commissioning_date: Yup.string().required('This field is required'),
    sn_partner: computerRequired
      ? Yup.number().required('This field is required')
      : Yup.number().optional(),
  });

export const originalValidationSchemeAgent = (
  checkSn: (
    value: number,
    p: TestContext<AnyObject>
  ) => Promise<boolean | ValidationError>
) =>
  Yup.object({
    sn: validateSn(checkSn),
    sn_partner: Yup.number().optional(),
    imo_nr: Yup.number().required('This field is required'),
    schiffsname: Yup.string().required('This field is required'),
    commissioning_date: Yup.string().required('This field is required'),
  });
